import React from "react";
import { useTranslation } from "react-i18next";

import Button from "./Button";

function PageSkeleton({ titleKey, descriptionKey, sections = [] }) {
  const { t } = useTranslation();

  return (
    <main className="bg-white">
      <section className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[60px] xl:pt-[100px] pb-[80px] xl:pb-[140px]">
        <div className="grid xl:grid-cols-[1fr_420px] gap-[40px] xl:gap-[80px] items-start">
          <div>
            <p className="zen-dots leading-[1.2] text-[34px] xl:text-[64px] text-[#1E1C21]">
              Treefield Partners AG
            </p>
            <h1 className="zen-dots leading-[1.2] text-[24px] xl:text-[44px] text-[#1E1C21] mt-[12px]">
              {t(titleKey)}
            </h1>
            <p className="xl:max-w-[520px] text-[#000000B2] text-[14px] ibm-plex mt-[20px] xl:mt-[36px]">
              {t(descriptionKey)}
            </p>
            <Button className="mt-[36px] xl:mt-[56px]" />
          </div>

          <div className="border border-[#CED1DF] bg-[#F1F1F1] min-h-[260px] xl:min-h-[360px] p-[20px] xl:p-[30px] flex flex-col justify-between">
            <p className="ibm-plex text-[13px] text-[#000000B2] uppercase">
              {t("skeleton.heroLabel")}
            </p>
            <div className="space-y-[10px]">
              <div className="h-[12px] bg-[#CED1DF]" />
              <div className="h-[12px] bg-[#CED1DF] w-2/3" />
              <div className="h-[12px] bg-[#CED1DF] w-1/2" />
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-[1220px] mx-[20px] xl:mx-auto pb-[80px] xl:pb-[150px]">
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-[20px]">
          {sections.map((sectionKey, index) => (
            <article
              key={sectionKey}
              className="border border-[#CED1DF] bg-[#FFFFFF] min-h-[220px] p-[20px] xl:p-[30px] flex flex-col justify-between"
            >
              <div>
                <p className="ibm-plex text-[12px] text-[#00000080]">
                  {String(index + 1).padStart(2, "0")}
                </p>
                <h2 className="zen-dots text-[18px] xl:text-[24px] text-[#1E1C21] mt-[16px]">
                  {t(`${sectionKey}.title`)}
                </h2>
              </div>
              <p className="ibm-plex text-[14px] text-[#000000B2] mt-[24px]">
                {t(`${sectionKey}.text`)}
              </p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default PageSkeleton;
